import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import PrompterRTE from 'shared/components/rte/prompterRTE';
/**
 * PrompterRowEditor
 */
class PrompterRowEditor extends Component {
  constructor(props) {
    super(props);
    this._handleClick = this._handleClick.bind(this);
  }

  render() {
    const {
      height,
      editorState,
      onExternalContentChange,
      onStopEdit,
      onWillUnmount,
      wrapperClassName,
      isEditing,
      zoom,
      lineHeight,
      placeholder,
      scrollTop,
      onScroll,
      viewType,
      toolbarStyle,
    } = this.props;

    return (
      <div
        aria-label="RTE Editor"
        className={classNames('rte-featured', {
          'rte-featured-editing': isEditing,
        })}
        ref={(ref) => (this._outerContainer = ref)}
        onClick={this._handleClick}
      >
        <div className="rte-featured-editor">
          <PrompterRTE
            readOnly={!isEditing}
            toolbarStyle={toolbarStyle}
            scrollTop={scrollTop}
            onScroll={onScroll}
            height={height}
            displayToolbar
            autoFocus
            editorState={editorState}
            resize={false}
            onExternalContentChange={onExternalContentChange}
            wrapperClassName={wrapperClassName}
            onContentChange={onStopEdit}
            viewType={viewType}
            disableBlur
            editorClassName={isEditing ? 'rte-editor-editing' : ''}
            zoom={zoom}
            lineHeight={lineHeight}
            placeholder={placeholder}
            onWillUnmount={onWillUnmount}
          />
        </div>
      </div>
    );
  }

  _handleClick() {
    const {
      isEditing,
      isSelected,
      onSelect,
      onStartEdit,
      corrupted,
    } = this.props;

    if (!isEditing && !isSelected) {
      onSelect();
    } else if (isSelected && !isEditing) {
      //Prevent user from going into edit mode of corrupted cells.
      if (!corrupted) onStartEdit();
    }
  }
}

PrompterRowEditor.defaultProps = {
  placeholder: '',
  scrollTop: 0,
};

PrompterRowEditor.propTypes = {
  corrupted: PropTypes.bool,
  height: PropTypes.number,
  editorState: PropTypes.object,
  onWillUnmount: PropTypes.func,
  zoom: PropTypes.string,
  lineHeight: PropTypes.number,
  viewType: PropTypes.string,
  toolbarStyle: PropTypes.object,
  isEditing: PropTypes.bool,
  isSelected: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onStartEdit: PropTypes.func.isRequired,
  onStopEdit: PropTypes.func.isRequired,
  onExternalContentChange: PropTypes.func,
  placeholder: PropTypes.string,
  scrollTop: PropTypes.number,
  onScroll: PropTypes.func,
};

export default PrompterRowEditor;
